import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 const PostRemoveMobileAppHandler = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.RemoveMobileAppHandler+"/"+data+"/delete",
   method: RequestType.DELETE,
   data,
 }); 
 const PutMobileAppHandler = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.UpdateMobileAppHandler,
   method: RequestType.PUT,
   data, 
 }); 
 const CreateMobileAppHandler = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.CreateMobileAppHandler,
   method: RequestType.POST,
   data, 
 }); 
 const CreateMobileAppHandlerV2 = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.CreateMobileAppHandlerV2,
   method: RequestType.POST,
   data, 
 }); 


 const MobileAppHandlerCommand = {
    PostRemoveMobileAppHandler,
    PutMobileAppHandler,
    CreateMobileAppHandler,
    CreateMobileAppHandlerV2
  
  }
  
  export default MobileAppHandlerCommand;